exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n\r\nheader.styles--appBar--1fs5Zu2q {\r\n  background-color: rgb(25, 118, 210);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"appBar": "styles--appBar--1fs5Zu2q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/components/AppBar/styles.css
// module id = 1059
// module chunks = 1